import { render, staticRenderFns } from "./wolt_general_tab.vue?vue&type=template&id=3e50d21a&scoped=true&"
import script from "./wolt_general_tab.vue?vue&type=script&lang=js&"
export * from "./wolt_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50d21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e50d21a')) {
      api.createRecord('3e50d21a', component.options)
    } else {
      api.reload('3e50d21a', component.options)
    }
    module.hot.accept("./wolt_general_tab.vue?vue&type=template&id=3e50d21a&scoped=true&", function () {
      api.rerender('3e50d21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/wolt/location/tabs/wolt_general_tab.vue"
export default component.exports